import { httpClient } from '@/utils/http-client';
class ThumbTemplatesService {
    httpClient;
    constructor() {
        this.httpClient = httpClient;
    }
    formatObject(template) {
        let isFavorite = false;
        if (template.userTemplates && template.userTemplates.length >= 1) {
            isFavorite = true;
        }
        return {
            id: template.id,
            title: template.title,
            preview: template.preview?.remoteUrl,
            content: template.content,
            width: template.width,
            height: template.height,
            shape: template.shape,
            tags: template.tags,
            isFeatured: template.isFeatured,
            isFavorite: isFavorite,
            isFree: template.isFree,
            devalueLevel: template.devalueLevel
        };
    }
    async getTemplate(id) {
        const response = await this.httpClient.get('/thumbtemplates/' + id);
        return this.formatObject(response.data);
    }
    async getTemplatesList(page, limit, shape, tags, favorites, type = 'quote') {
        const response = await this.httpClient.get('/thumbtemplates', {
            params: {
                page: page,
                limit: limit,
                shape: shape,
                tags: tags,
                favorites: favorites,
                type: type
            }
        });
        return response.data.items.map((template) => {
            return this.formatObject(template);
        });
    }
    async deleteTemplate(id) {
        const response = await this.httpClient.delete('/thumbtemplates/' + id);
        if (response.data)
            return true;
        return false;
    }
    async featureTemplate(id, feature) {
        const response = await this.httpClient.patch('/thumbtemplates/' + id, {
            isFeatured: feature
        });
        if (response.data)
            return true;
        return false;
    }
    async setFavorite(id) {
        try {
            const response = await this.httpClient.post('/user-thumbtemplates', {
                templateId: id
            });
            if (response.data)
                return true;
            return false;
        }
        catch (error) {
            return false;
        }
    }
    async setDevalue(id, value) {
        try {
            const response = await this.httpClient.patch(`/thumbtemplates/devalue/${id}`, {
                devalueLevel: value
            });
            return response.data.result === true;
        }
        catch (error) {
            return false;
        }
    }
}
export default ThumbTemplatesService;
